/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

export const ERROR_ALL_FIELDS_REQUIRED = "All fields need to be completed before continuing";
export const RADIO_BUTTONS_ERROR_TEXT = "Please make a selection before continuing";
export const HELP_LINK = "https://hr.jpmorganchase.com/hr?id=kb_article&sysparm_article=KB0010463";
export const SOMETHING_WENT_WRONG = `Something went wrong. Please try again in a few moments. If the issue continues, please contact <a href='${HELP_LINK}' target='_blank' class='help-link'>Ask JPMC</a> for assistance.`;
export const WORKSPACE_LINK_EXTERNAL = "workspace.jpmchase.com";
export const WORKSPACE_LINK_EXTERNAL_NO_SLO = "myworkspace.jpmchase.com";
export const CANNOT_RESET_PASSWORD = "We're having trouble checking your new password right now. Please try again in a few moments. If the problem persists, please contact the help desk for assitance.";
export const ALPHANUMERIC_WITH_SPACES_REGEX = /^[a-zA-Z0-9\s]+$/;
export const VALIDATE_IDENTITY_ERROR_CONTENT = `There was an issue with the information you entered or something went wrong on our end.
  Please try again, ensuring all details are correct. If the problem persists,
  speak to your manager or contact <a href='${HELP_LINK}' target='_blank' class='help-link'>Ask JPMC</a> for support.`;
export const DEVICE_REGISTERED_ERROR = "Sorry, it's currently not possible to register more than 1 device for Smart Log On. Please visit the Smart Log On management portal to manage your devices.";
export const STEP_PERFORMED = 0;
export const STEP_NOT_STARTED = 1;
export const STEP_SKIPPED = 2;
export const NOT_ALLOWED_TO_ONBOARD_TODAY = "You are not authorized to onboard today. Please contact your manager.";
export const ONBOARDED_USER = "It looks like you already have an active account.  If you have forgotten your password you update it via the button below";
